export interface IInvoice {
  id: string;
  downloadPdfUrl: string;
  invoicePayUrl: string;
  date: string;
  amount: number;
  status: string;
  currency: string;
  description: string;
  confirmationClientSecret: string;
}

export enum InvoiceStatus {
  Draft = "draft",
  Open = "open",
  Paid = "paid",
  Uncollectible = "uncollectible",
  Void = "void"
}

export interface IPaymentIntent {
  id: string,
  status: string;
  clientSecret: string;
}

export interface InvoicesSliceInitialState {
  invoices: IInvoice[];
  isLoading: boolean;
}

export type InvoiceTableHeadings =
  | 'Date'
  | 'Amount'
  | 'Description'
  | 'Status'
  | 'Download';
